import {
  IndustryTableData,
  IndustryOptionsActivityLog,
} from 'components/IndustryOptions/types';
import { ApiListResp } from 'models/api';
import { apiV2 } from './axios';

export const getIndustryOptions = async (): Promise<IndustryTableData[]> => {
  const { data } = await apiV2.get<IndustryTableData[]>('industry-options');
  return data;
};

export const getIndustryOptionsActivity = async (
  page: number = 1,
): Promise<ApiListResp<IndustryOptionsActivityLog[]>> => {
  const { data } = await apiV2.get<ApiListResp<IndustryOptionsActivityLog[]>>(
    'industry-options/op-logs',
    {
      params: { page },
    },
  );
  return data;
};

export const updateIndustryOptions = async (
  params: IndustryTableData,
): Promise<IndustryTableData> => {
  const { data } = await apiV2.put<IndustryTableData>(
    'industry-options',
    params,
  );
  return data;
};

export const createIndustryOptions = async (
  params: IndustryTableData,
): Promise<void> => {
  await apiV2.post('industry-options', params);
};
